// extracted by mini-css-extract-plugin
module.exports = {"info_line":"styles_info_line__2oz-V"};